<div class="login-screen">
    <div class="wrapper-reponsive">
        <div class="content-box mt-2 mb-2 p-4">
            <div class="tlt-green-row mb-2">
                {{ 'STR_SEND_VERIFY_EMAIL' | translate }}
            </div>
            <p class="p-2">
                {{ 'STR_VERIFY_EMAIL_NOTE' | translate}}
            </p>
            <div class="row-input row-input-auto-height p-4 mb-4">
                <div class="pl-3">
                    <div class="tlt-dot mb-1">{{ 'STR_EMAIL_ADDRESS' | translate}}</div>
                    <!-- 20250407 #24888 modify start -->
                    <!-- <input type="text" (ngModelChange)="removeBorder()" class="ctrl form-control mb-3" maxlength="255" [(ngModel)]="mailAddress"  oninput="let p=this.selectionStart;this.value=this.value.toLowerCase();this.setSelectionRange(p, p);" (keypress)="checkMail($event)"> -->
                    <input type="text" (ngModelChange)="removeBorder()" class="ctrl form-control mb-3" maxlength="255" [(ngModel)]="mailAddress"  oninput="let p=this.selectionStart;let start = input.selectionStart;let end = input.selectionEnd;setTimeout(() => {  this.value=this.value.toLowerCase();this.setSelectionRange(start, end);}, 0); " (keypress)="checkMail($event)">
                    <!-- 20250407 #24888 modify end -->
                </div>
                <div  *ngIf="isMailErr" class="pl-3 err-validate">
                    <span>{{errMsg}}</span>
                </div>
            </div>
            <div class="text-center mt-2">
                <button class="btn btn-common btn-bg-green" style="margin-bottom:15px" (click)="sendMail()">
                   {{ 'STR_BTN_SEND_MAIL' | translate}}
                </button>
                <br/>
                <button class="btn btn-common btn-bg-yellow" (click)="goLogin()">
                {{ 'STR_LOGIN_CLICK' | translate}}
                </button>
            </div>
        </div>
    </div>
</div>